import { render, staticRenderFns } from "./ServiceDataCell.vue?vue&type=template&id=5bf8ae0e&scoped=true&lang=html&"
import script from "./ServiceDataCell.vue?vue&type=script&lang=js&"
export * from "./ServiceDataCell.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDataCell.vue?vue&type=style&index=0&id=5bf8ae0e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8ae0e",
  null
  
)

export default component.exports